import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import FormulaireDedicace from '../components/FormulaireDedicace.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.app = createApp({
            template: '<FormulaireDedicace />',
            components: {
                FormulaireDedicace
            },
            data() {
                return {
                    //dates: dates
                }
            },
            mounted() {
            },
        })
        this.app.mount(this.el)
    }

    destroy() {
        this.app.unmount()
    }
}

